import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { AuthProvider } from './contexts/AuthContext'
import { GoogleAnalytics } from './components/GoogleAnalytics'

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <GoogleAnalytics />
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App